import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
    PERMISSION_VACANCIES_READ,
    PERMISSION_TALENTS_READ
  } from '../../constants'
import WithAjax from '../common/helpers/WithAjax'
import {fetchProductionVacanciesSuccess} from '../../actions/pages/production-page'
import {checkPermission} from '../common/functions/permissions'
import {pushVacancy} from '../common/functions/push'
import Table from '../../tables/reactable/DefaultTable'
import StatusBadge from '../common/helpers/StatusBadge'
import Alert from '../../ui-elements/alerts/Alert'

class VacanciesGrid extends Component {
  constructor() {
    super()
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.onFilter = this.onFilter.bind(this)
    this.onPush = this.onPush.bind(this)
    this.fetchProductionVacanciesData = this.fetchProductionVacanciesData.bind(this)
    this.state = {
      itemsPerPage: 10,
      openBtnVisible: checkPermission(PERMISSION_VACANCIES_READ),
      openBtnLabel: 'View',
      pushBtnLabel: 'Push',
      search: '',
      filter: {
        Status: ''
      }
    }
    this.columns = [
      'SkillTypeLabel',
      'Description',
      'StartDate',
      'Status',
      'NameOrCandidatesNumber'
    ]
    this.columnNames = [
      'Speciality',
      'Description',
      'Schedule',
      'Status',
      'Name / Candidates'
    ]
  }

  componentDidMount() {
    if (this.props.vacancies === null){
        this.fetchProductionVacanciesData();
    }
  }

  fetchProductionVacanciesData(){
    let url = 'productions/' + this.props.productionId + '/vacancies'

    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        data[index].NavigationParam = data[index].Id;
      });

      this.props.fetchProductionVacanciesSuccess(data);
    });
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  onSearch(e) {
    e.preventDefault()
    this.setState({
      search: e.target.value
    })
    return false
  }

  onFilter(filter){
    this.setState({
      filter: filter
    })
  }



  onPush(vacancyId){
    pushVacancy(vacancyId, this.props.ajax.put, this.fetchProductionVacanciesData, this);
  }

  render() {
    if (this.props.vacancies === null) {
      return (<div />)
    }

    let items = this.props.vacancies.map(item => {
      return Object.assign({}, item, {
        Status: (<StatusBadge status={item.Status.toLowerCase()} statusLabel={item.Status} />),
        StartDate: item.StartDate ? (<span startdate={item.StartDate}>{item.Schedule}</span>): (null),
        NameOrCandidatesNumber: item.HiredCancidate
          ? checkPermission(PERMISSION_TALENTS_READ)
              ? (<a href={'/talents/' + item.HiredCandidateId + '/overview'}>{item.HiredCancidate}</a>)
              : (<span>{item.HiredCancidate}</span>)
          : item.NumberOfEngagedCandidates + ' of ' + item.NumberOfCandidates
      })
    });

    return (
      <div>
        {this.state.errorMsg &&
          <div className="col-md-12">
            <Alert className="alert alert-danger alert-outline">
              {this.state.errorMsg}
            </Alert>
          </div>
        }
        <Table
          items={items}
          columns={this.columns}
          columnNames={this.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={this.state.openBtnVisible}
          openBtnLabel={this.state.openBtnLabel}
          openBtnHref="/vacancies/{NavigationParam}/overview"
          pushBtnLabel={this.state.pushBtnLabel}
          pushBtnFn={this.onPush}
          searchable={[
            'SkillTypeLabel',
            'Description'
          ]}
          search={this.state.search}
          onSearch={this.onSearch}
          filterable={[{
            column: 'Status',
            filters:[
              {
                value: 'draft',
                label: 'Draft'
              },
              {
                value: 'active',
                label: 'Active'
              },
              {
                value: 'booked',
                label: 'Booked'
              },
              {
                value: 'closed',
                label: 'Closed'
              }
            ]
          }]}
          filter={this.state.filter}
          onFilter={this.onFilter}
          sortable={[
            'SkillTypeLabel',
            'Description',
            {
                column: 'Status',
                sortFunction: function(a, b) {
                  return a.props.statusLabel.localeCompare(b.props.statusLabel);
                }
            },
            {
              column: 'StartDate',
              sortFunction: function(a, b) {
                return a.props ? a.props.startdate.localeCompare(b.props.startdate): 0;
              }
            }
          ]}
          defaultSort={{column: 'SkillTypeLabel', direction: 'asc'}}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  vacancies: state.productionPage.vacancies
})
const mapDispatchToProps = dispatch => ({
  fetchProductionVacanciesSuccess(vacancies) { dispatch(fetchProductionVacanciesSuccess(vacancies)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(VacanciesGrid))
